// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__G+gpt","container":"Navbar_container__oUshM","logo":"Navbar_logo__Tl41b","navLinks":"Navbar_navLinks__UFXif"};